import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/document-services/document-services/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const TitleBlock = makeShortcode("TitleBlock");
const TextBlock = makeShortcode("TextBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <TitleBlock slots="heading, text" theme="light" className="titleBlock-align-left" mdxType="TitleBlock" />
    <h2 {...{
      "id": "get-started-in-minutes"
    }}>{`Get started in minutes`}</h2>
    <p>{`Start with the Free Tier and get 500 free Document Transactions per month.`}</p>
    <TextBlock slots="heading, text, buttons" theme="light" width="33%" className="align-left  stepper-horizontal-align" mdxType="TextBlock" />
    <h2 {...{
      "id": "step-1"
    }}>{`Step 1`}</h2>
    <p>{`Start a free tier and download code samples for Node.js, Java, .Net, and Python`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://acrobatservices.adobe.com/dc-integration-creation-app-cdn/main.html?api=document-generation-api"
        }}>{`Get started`}</a></li>
    </ul>
    <TextBlock slots="heading, text, buttons" theme="light" width="33%" variantsTypePrimary="secondary" variantStyleFill="outline" isPrimaryBtn className="align-left link  stepper-horizontal-align linking" mdxType="TextBlock" />
    <h2 {...{
      "id": "step-2"
    }}>{`Step 2`}</h2>
    <p>{`Get the Adobe Document Tagger Microsoft Word add-in and check out our `}<a parentName="p" {...{
        "href": "#sample-blade"
      }}>{`sample templates.`}</a></p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/document-services/document-services/docs/overview/document-generation-api/wordaddin/"
        }}>{`Get Word add-in`}</a></li>
    </ul>
    <TextBlock slots="heading, text, buttons" theme="light" width="33%" variantsTypePrimary="secondary" variantStyleFill="outline" isPrimaryBtn className="align-left link  stepper-horizontal-align extract-stepper-api-reference linking" mdxType="TextBlock" />
    <h2 {...{
      "id": "step-3"
    }}>{`Step 3`}</h2>
    <p>{`Add credentials to your code and run!  `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/document-services/docs/apis/#tag/Document-Generation"
      }}>{`API Reference`}</a></p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/document-services/document-services/docs/overview/document-generation-api/"
        }}>{`See documentation`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      